import React from 'react';
import { NavigateReduxMapper } from '../navigate-redux-mapper/view.tsx';
import AppBase, { type AutomationAppBaseProps } from './view';

export type ServiceDeskAutomationAppBaseProps = {
	baseUrl: string;
} & AutomationAppBaseProps;

const ServiceDeskAutomationAppBase = ({
	baseUrl,
	appName,
	...props
}: ServiceDeskAutomationAppBaseProps) => (
	<NavigateReduxMapper name={`${appName}-navigator`} baseUrl={baseUrl}>
		<AppBase appName={appName} {...props} />
	</NavigateReduxMapper>
);

ServiceDeskAutomationAppBase.defaultProps = {
	children: null,
	// Replace with lodash/noop
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	onErrorHandler: () => {},
	loadLegacyModules: false,
};

export default ServiceDeskAutomationAppBase;
